// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountOperationType;
(function (AccountOperationType) {
    AccountOperationType[AccountOperationType["Unknown"] = 0] = "Unknown";
    AccountOperationType[AccountOperationType["Trading"] = 1] = "Trading";
    AccountOperationType[AccountOperationType["Deposit"] = 2] = "Deposit";
    AccountOperationType[AccountOperationType["Withdraw"] = 3] = "Withdraw";
    AccountOperationType[AccountOperationType["Brokerage"] = 4] = "Brokerage";
    AccountOperationType[AccountOperationType["swap"] = 5] = "swap";
    AccountOperationType[AccountOperationType["MinFeeAdjEquity"] = 6] = "MinFeeAdjEquity";
    AccountOperationType[AccountOperationType["Blocking"] = 7] = "Blocking";
    AccountOperationType[AccountOperationType["Unblocking"] = 8] = "Unblocking";
    AccountOperationType[AccountOperationType["ManufacturedDividends"] = 9] = "ManufacturedDividends";
    AccountOperationType[AccountOperationType["interest"] = 10] = "interest";
    AccountOperationType[AccountOperationType["Adjustment"] = 12] = "Adjustment";
    AccountOperationType[AccountOperationType["dividends"] = 13] = "dividends";
    AccountOperationType[AccountOperationType["StockOperation"] = 14] = "StockOperation";
    AccountOperationType[AccountOperationType["AccruedInterest"] = 15] = "AccruedInterest";
    AccountOperationType[AccountOperationType["Subscribe"] = 16] = "Subscribe";
    AccountOperationType[AccountOperationType["Transfer"] = 17] = "Transfer";
    AccountOperationType[AccountOperationType["Spread"] = 18] = "Spread";
    AccountOperationType[AccountOperationType["Credit"] = 19] = "Credit";
    AccountOperationType[AccountOperationType["Premium"] = 21] = "Premium";
    AccountOperationType[AccountOperationType["DeliveredForward"] = 22] = "DeliveredForward";
    AccountOperationType[AccountOperationType["PAMMTransfer"] = 23] = "PAMMTransfer";
    AccountOperationType[AccountOperationType["DWT"] = 24] = "DWT";
    AccountOperationType[AccountOperationType["ValueAddedTax"] = 25] = "ValueAddedTax";
    AccountOperationType[AccountOperationType["Exchange"] = 26] = "Exchange";
    AccountOperationType[AccountOperationType["SecuritiesTransferTax"] = 27] = "SecuritiesTransferTax";
    AccountOperationType[AccountOperationType["SettlementFee"] = 28] = "SettlementFee";
    AccountOperationType[AccountOperationType["InvestorProtectionLevy"] = 29] = "InvestorProtectionLevy";
    AccountOperationType[AccountOperationType["Delivery"] = 30] = "Delivery";
    AccountOperationType[AccountOperationType["addliquidityrebate"] = 31] = "addliquidityrebate";
    AccountOperationType[AccountOperationType["removeliquidityrebate"] = 32] = "removeliquidityrebate";
    AccountOperationType[AccountOperationType["withdrawalfee"] = 33] = "withdrawalfee";
    AccountOperationType[AccountOperationType["Markup"] = 34] = "Markup";
    AccountOperationType[AccountOperationType["PortfolioManagementFee"] = 35] = "PortfolioManagementFee";
    AccountOperationType[AccountOperationType["PortfolioManagementMinFeeAdj"] = 36] = "PortfolioManagementMinFeeAdj";
    AccountOperationType[AccountOperationType["ClearingVmTransfer"] = 40] = "ClearingVmTransfer";
    AccountOperationType[AccountOperationType["Level1DataCharging"] = 41] = "Level1DataCharging";
    AccountOperationType[AccountOperationType["Level2DataCharging"] = 42] = "Level2DataCharging";
    AccountOperationType[AccountOperationType["Level3DataCharging"] = 43] = "Level3DataCharging";
    AccountOperationType[AccountOperationType["DelayedDataCharging"] = 44] = "DelayedDataCharging";
    AccountOperationType[AccountOperationType["NewsCharging"] = 45] = "NewsCharging";
    AccountOperationType[AccountOperationType["MamPerformanceFee"] = 46] = "MamPerformanceFee";
    AccountOperationType[AccountOperationType["MamManagementFee"] = 47] = "MamManagementFee";
    AccountOperationType[AccountOperationType["Collateral"] = 48] = "Collateral";
    AccountOperationType[AccountOperationType["FixedIncomePayment"] = 49] = "FixedIncomePayment";
    AccountOperationType[AccountOperationType["InterestOnCash"] = 88] = "InterestOnCash";
    AccountOperationType[AccountOperationType["InterestOnMarginAvailable"] = 90] = "InterestOnMarginAvailable";
    AccountOperationType[AccountOperationType["InterestOnMarginAvailableAndUnsettledCash"] = 91] = "InterestOnMarginAvailableAndUnsettledCash";
    AccountOperationType[AccountOperationType["InterestOnAvailableFunds"] = 92] = "InterestOnAvailableFunds";
    AccountOperationType[AccountOperationType["IntererstOnAvailableFundsAndUnsettledCash"] = 93] = "IntererstOnAvailableFundsAndUnsettledCash";
    AccountOperationType[AccountOperationType["OpenOptionPremium"] = 94] = "OpenOptionPremium";
    AccountOperationType[AccountOperationType["CloseOptionPremium"] = 95] = "CloseOptionPremium";
    AccountOperationType[AccountOperationType["TransferFee"] = 96] = "TransferFee";
    AccountOperationType[AccountOperationType["FixedFee"] = 97] = "FixedFee";
    AccountOperationType[AccountOperationType["Custodial"] = 98] = "Custodial";
    AccountOperationType[AccountOperationType["ProductFee"] = 99] = "ProductFee";
    AccountOperationType[AccountOperationType["BalanceCredit"] = 100] = "BalanceCredit";
    AccountOperationType[AccountOperationType["BalanceDebit"] = 101] = "BalanceDebit";
    AccountOperationType[AccountOperationType["AccruedDividends"] = 102] = "AccruedDividends";
    AccountOperationType[AccountOperationType["DividendsTax"] = 103] = "DividendsTax";
    AccountOperationType[AccountOperationType["PrimeBroker"] = 104] = "PrimeBroker";
    AccountOperationType[AccountOperationType["CloseTminus1OptionPremium"] = 105] = "CloseTminus1OptionPremium";
    AccountOperationType[AccountOperationType["Funding"] = 106] = "Funding";
    AccountOperationType[AccountOperationType["FundingMarkup"] = 107] = "FundingMarkup";
    AccountOperationType[AccountOperationType["WhiteLabel"] = 108] = "WhiteLabel";
    AccountOperationType[AccountOperationType["CashInLieu"] = 109] = "CashInLieu";
    AccountOperationType[AccountOperationType["CouponPayment"] = 110] = "CouponPayment";
    AccountOperationType[AccountOperationType["PortfolioOvernightFee"] = 111] = "PortfolioOvernightFee";
    AccountOperationType[AccountOperationType["FreeCommission"] = 112] = "FreeCommission";
    AccountOperationType[AccountOperationType["CareOrder"] = 113] = "CareOrder";
    AccountOperationType[AccountOperationType["StampDuty"] = 114] = "StampDuty";
    AccountOperationType[AccountOperationType["CashDeposit"] = 1000] = "CashDeposit";
})(AccountOperationType || (AccountOperationType = {}));
class AccountOperationTypeClass {
    createMap() {
        const result = {};
        const keys = Object.keys(AccountOperationType);
        const len = keys.length;
        for (let i = 0; i < len; i++) {
            result[AccountOperationType[keys[i]]] = keys[i];
        }
        return result;
    }
    constructor() {
        this.mapStorrage = {};
        this.mapStorrage = this.createMap();
    }
    get TypeNames() {
        return this.mapStorrage;
    }
    getTypeName(type) {
        return this.mapStorrage[type];
    }
    getTypeLocalizationKey(type) {
        const typeName = this.getTypeName(type);
        return typeName === undefined ? undefined : 'reports.' + typeName;
    }
}
export const AccountOperations = new AccountOperationTypeClass();
